exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:fixed;z-index:4;bottom:0;left:0;right:0;top:0}.dialog--is-open{-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.dialog--is-close{display:none}.dialog__container{box-shadow:0 24px 26px 0 rgba(64,64,65,.5);max-width:80%;background-color:#fff;border-radius:4px;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Dialog/Dialog.scss
// module id = 789
// module chunks = 0 1